import { Pill } from '@/components/ui/pill'
import { getRosterStatusBadge } from '@/utils/statusColors'
import { DutyStatus } from '../../../api/src/shared'

export function formatDutyStatus(status: string): string {
  switch (status) {
    case 'OnDuty':
      return 'On Duty'
    case 'OffDuty':
      return 'Off Duty'
    case 'Standby':
      return 'Standby'
    case 'Training':
      return 'Training'
    case 'Leave':
      return 'Leave'
    case 'Sick':
      return 'Sick'
    case 'Positioning':
      return 'Positioning'
    default:
      return status
  }
}

export function DutyBadge({ status }: { status: string }) {
  if (status === 'OnDuty') {
    return <Pill variant="success">{formatDutyStatus(status)}</Pill>
  }
  if (status === 'OffDuty') {
    return <Pill variant="draft">{formatDutyStatus(status)}</Pill>
  }
  if (status === 'Leave' || status === 'Sick') {
    const { text, className } = getRosterStatusBadge(status as DutyStatus)
    return <Pill className={className}>{text}</Pill>
  }
  // Standby / Training / fallback — brand color, outside the Figma 5-variant set.
  return (
    <Pill className="bg-background-brand-subtle text-content-primary-bold">
      {formatDutyStatus(status)}
    </Pill>
  )
}
